module.exports = __webpack_public_path__ + "static/InputField_select-9a3da6cd0e0cd934aa415b54a94eb3e0.png";